import { render } from "./_select.vue?vue&type=template&id=22b0840c&scoped=true"
import script from "./_select.vue?vue&type=script&lang=js"
export * from "./_select.vue?vue&type=script&lang=js"

import "./_select.vue?vue&type=style&index=0&id=22b0840c&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22b0840c"]])

export default __exports__